/*
==========================================================
GLIA COMMERCE ENGINE
Version 6.0
==========================================================
*/

class GliaCommerce {

    constructor(config) {

        this.config = config;
        this.products = {};
        this.customMonthlyVariant = null;

this.selection = {

    tickets: {},

    donation: null,

    monthly: null,

    customDonation: null,

    customMonthly: null

};




        console.log("================================");
        console.log("Glia Commerce Engine Loaded");
        console.log("================================");

        this.initialize();

    }

    async initialize() {

        await this.loadProducts();

this.renderTickets();

this.renderDonations();

this.renderMonthly();

this.bindDonationToggle();

this.bindDonationButtons();

this.bindMonthlyToggle();

this.bindMonthlyButtons();

this.bindCustomAmounts();

console.log("Commerce Engine Ready");

    }

    async loadProducts() {

        const handles = this.config.products;

        this.products.ticket = await this.fetchProduct(handles.ticket);
        this.products.donation = await this.fetchProduct(handles.donation);
        this.products.monthly = await this.fetchProduct(handles.monthly);

        console.log("Products Loaded");
        console.log(this.products);

    }

    getVariant(product, variantId) {

        if (!product || !product.variants) return null;

        return product.variants.find(
            variant => Number(variant.id) === Number(variantId)
        ) || null;

    }

    getSellingPlanId(variant) {

        if (!variant) return null;

        const allocations = variant.selling_plan_allocations || [];

        if (!allocations.length) return null;

        return Number(allocations[0].selling_plan_id);

    }

    renderTickets() {

        console.log("Rendering tickets...");

        const container = document.getElementById("glia-ticket-list");

        if (!container) return;

        if (!this.products.ticket) return;

        container.innerHTML = "";

        this.products.ticket.variants.forEach(variant => {

            const price = (variant.price / 100).toFixed(2);

            container.insertAdjacentHTML("beforeend", `

                <div class="event-ticket">

                    <div class="event-ticket__info">

                        <div class="event-ticket__name">
                            ${variant.title}
                        </div>

                    </div>



                    <div class="event-ticket__quantity">

                        <button
                            type="button"
                            class="glia-minus"
                            data-variant="${variant.id}">

                            -

                        </button>

                        <span>0</span>

                        <button
                            type="button"
                            class="glia-plus"
                            data-variant="${variant.id}">

                            +

                        </button>

                    </div>

                </div>

            `);

        });

        this.bindTicketButtons();
        this.updateTotal();
        this.bindReserveButton();

}



renderDonations() {

    const container = document.getElementById("glia-donation-list");

    if (!container) return;

    if (!this.products.donation) return;

    container.innerHTML = "";

    this.products.donation.variants
        .filter(variant => variant.price >= 2500)
        .forEach(variant => {

            const price = (variant.price / 100).toFixed(0);

            container.insertAdjacentHTML("beforeend", `

                <label class="glia-donation-card">

                    <input
                        type="radio"
                        name="glia-donation"
                        value="${variant.id}"
                        data-price="${variant.price}">

                    <span class="glia-donation-card__amount">

                        $${price}

                    </span>

                </label>

            `);

        });

    container.insertAdjacentHTML("beforeend", `

        <div class="glia-custom-card">

            <input
                type="number"
                id="glia-custom-amount"
                min="1"
                step="1"
                placeholder="Custom Amount">

        </div>

    `);

}

bindCustomAmounts() {

    const donation = document.getElementById("glia-custom-amount");

    if (donation) {

        donation.addEventListener("input", () => {

            const amount = parseInt(donation.value) || 0;

            this.selection.customDonation = amount;

            this.selection.donation = null;

            document
                .querySelectorAll('input[name="glia-donation"]')
                .forEach(radio => radio.checked = false);

            this.updateTotal();

        });

    }

    const monthly = document.getElementById("glia-custom-monthly");

    if (monthly) {

        monthly.addEventListener("input", () => {

            const amount = parseInt(monthly.value) || 0;

            this.selection.customMonthly = amount;

            this.selection.monthly = null;

            document
                .querySelectorAll('input[name="glia-monthly"]')
                .forEach(radio => radio.checked = false);

            this.updateTotal();

        });

    }

}


bindDonationToggle() {

    const button = document.getElementById("glia-donation-toggle");
    const panel = document.getElementById("glia-donation-content");

    if (!button || !panel) return;

    const label = button.querySelector("span");

    button.addEventListener("click", () => {

        const open = panel.style.display === "block";

        panel.style.display = open ? "none" : "block";

        label.textContent = open
            ? "[ ] Add a Donation"
            : "[x] Add a Donation";

    });

}

bindDonationButtons() {

    document
        .querySelectorAll('input[name="glia-donation"]')
        .forEach(input => {

            input.addEventListener("change", () => {

                this.selection.donation = {

                    id: Number(input.value),

                    amount: Number(input.dataset.price)

                };

                this.updateTotal();

                console.log(this.selection.donation);

            });

        });

}


renderMonthly() {

    const container = document.getElementById("glia-monthly-list");

    if (!container) return;

    if (!this.products.monthly) return;

    container.innerHTML = "";

    this.products.monthly.variants
        .filter(variant => variant.price >= 2500)
        .forEach(variant => {

            const price = (variant.price / 100).toFixed(0);

            container.insertAdjacentHTML("beforeend", `

                <label class="glia-donation-card">

                    <input
                        type="radio"
                        name="glia-monthly"
                        value="${variant.id}"
                        data-price="${variant.price}">

                    <span class="glia-donation-card__amount">

                        $${price}<small>/mo</small>

                    </span>

                </label>

            `);

        });

    this.customMonthlyVariant = this.products.monthly.variants.find(
        variant => String(variant.title || "").toLowerCase().includes("custom")
    ) || this.getVariant(this.products.monthly, 44452223287395);

    container.insertAdjacentHTML("beforeend", `

        <div class="glia-custom-card">

            <input
                type="number"
                id="glia-custom-monthly"
                min="1"
                step="1"
                placeholder="Custom Amount">

        </div>

    `);

}

bindMonthlyToggle() {

    const button = document.getElementById("glia-monthly-toggle");
    const panel = document.getElementById("glia-monthly-content");

    if (!button || !panel) return;

    const label = button.querySelector("span");

    button.addEventListener("click", () => {

        const open = panel.style.display === "block";

        panel.style.display = open ? "none" : "block";

        label.textContent = open
            ? "[ ] Become a Monthly Supporter"
            : "[x] Become a Monthly Supporter";

    });

}


bindMonthlyButtons() {

    document
        .querySelectorAll('input[name="glia-monthly"]')
        .forEach(input => {

            input.addEventListener("change", () => {

                const variant = this.getVariant(
                    this.products.monthly,
                    input.value
                );

                this.selection.monthly = {

                    id: Number(input.value),

                    amount: Number(input.dataset.price),

                    sellingPlanId: this.getSellingPlanId(variant)

                };

                console.log(this.selection.monthly);
                this.updateTotal();

            });

        });

}


    bindTicketButtons() {

        document.querySelectorAll(".glia-plus").forEach(button => {

            button.addEventListener("click", () => {

                this.changeQuantity(button.dataset.variant, 1);

            });

        });

        document.querySelectorAll(".glia-minus").forEach(button => {

            button.addEventListener("click", () => {

                this.changeQuantity(button.dataset.variant, -1);

            });

        });

    }

    changeQuantity(variantId, change) {

        if (!this.selection.tickets[variantId]) {

    this.selection.tickets[variantId] = 0;

}

this.selection.tickets[variantId] += change;

if (this.selection.tickets[variantId] < 0) {

    this.selection.tickets[variantId] = 0;

}

this.updateTicketDisplay();
this.updateTotal();
    }

updateTicketDisplay() {

    document.querySelectorAll(".event-ticket").forEach(ticket => {

        const plus = ticket.querySelector(".glia-plus");
        const quantity = ticket.querySelector("span");

        const variantId = plus.dataset.variant;

quantity.textContent = this.selection.tickets[variantId] || 0;
    });

}

updateTotal() {

    let total = 0;

    for (const variantId in this.selection.tickets) {

        const qty = this.selection.tickets[variantId];

        const variant = this.products.ticket.variants.find(

            v => String(v.id) === String(variantId)

        );

        if (variant) {

            total += qty * (variant.price / 100);

        }

    }

    if (this.selection.donation) {

        total += this.selection.donation.amount / 100;

    }

    //
// Custom One-Time Donation
//

if (this.selection.customDonation) {

    total += this.selection.customDonation;

}

//
// Monthly (display only for now)
//

if (this.selection.monthly) {

    total += this.selection.monthly.amount / 100;

}

//
// Custom Monthly (display only)
//

if (this.selection.customMonthly) {

    total += this.selection.customMonthly;

}

    const totalElement = document.getElementById("glia-total");

    if (totalElement) {

        totalElement.textContent = `$${total.toFixed(2)} CAD`;

    }

}

bindReserveButton() {

    const button = document.getElementById("reserve-seats");

    if (!button) return;

    button.addEventListener("click", () => {

        this.reserveSeats();

    });

}


async reserveSeats() {

    const items = [];

    //
    // Tickets
    //

    for (const variantId in this.selection.tickets) {

        const qty = this.selection.tickets[variantId];

        if (qty < 1) continue;

        items.push({

            id: Number(variantId),

            quantity: qty,

            properties: {

                Event: this.config.campaign,
                Date: this.config.event.date,
                Venue: this.config.event.venue,

            }

        });

    }

    //
    // Preset One-Time Donation
    //

    if (this.selection.donation) {

        items.push({

            id: this.selection.donation.id,

            quantity: 1,

            properties: {

                Event: this.config.campaign,
                Type: "One-Time Donation",
            }

        });

    }

    //
    // Custom One-Time Donation
    //

    if (this.selection.customDonation) {

        items.push({

            id: 44452222107747,

            quantity: this.selection.customDonation,

            properties: {

                Event: this.config.campaign,
                Type: "Custom One-Time Donation",
            }

        });

    }

    //
    // Preset Monthly
    //

    if (this.selection.monthly) {

        if (!this.selection.monthly.sellingPlanId) {

            alert("This monthly donation is not connected to a Shopify monthly plan. Please contact us or choose another amount.");

            return;

        }

        items.push({

            id: this.selection.monthly.id,

            quantity: 1,

            selling_plan: this.selection.monthly.sellingPlanId,

            properties: {

                Event: this.config.campaign,
                Type: "Monthly Support",
            }

        });

    }

    //
    // Custom Monthly
    //

    if (this.selection.customMonthly) {

        const customMonthlyVariant = this.customMonthlyVariant;
        const sellingPlanId = this.getSellingPlanId(customMonthlyVariant);

        if (!customMonthlyVariant || !sellingPlanId) {

            alert("Custom monthly donations are not connected to a Shopify monthly plan. Please contact us or choose a listed amount.");

            return;

        }

        items.push({

            id: Number(customMonthlyVariant.id),

            quantity: this.selection.customMonthly,

            selling_plan: sellingPlanId,

            properties: {

                Event: this.config.campaign,
                Type: "Custom Monthly Support",
            }

        });

    }

    //
    // Nothing Selected
    //

    if (!items.length) {

        alert("Please select at least one ticket, donation, or monthly support.");

        return;

    }

    //
    // Add to Shopify
    //

    const response = await fetch("/cart/add.js", {

        method: "POST",

        headers: {

            "Content-Type": "application/json"

        },

        body: JSON.stringify({

            items: items

        })

    });

    if (!response.ok) {

        alert("Unable to add items to your cart.");

        return;

    }

window.location.href = "/cart";
}

    async fetchProduct(handle) {

        if (!handle) return null;

        try {

            const response = await fetch(`/products/${handle}.js`);

            if (!response.ok) {

                throw new Error(`Unable to load ${handle}`);

            }

            return await response.json();

        }

        catch (error) {

            console.error(error);

            return null;

        }

    }

}

document.addEventListener("DOMContentLoaded", () => {

    if (!window.Glia?.Commerce) return;

    window.Glia.Commerce.Engine = new GliaCommerce(window.Glia.Commerce);

});


